if (!customElements.get('product-form-pre-order')) {
  customElements.define(
    'product-form-pre-order',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.REFORMER_IDS = [8705932132642, 8705937211682, 8705939472674];
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.productId = this.getAttribute('data-product');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async checkBundledProductInventory(variantId, locationId) {
        try {
          const response = await fetch('https://handler-dboxw2azvq-uc.a.run.app/', {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ variantId, locationId }),
          });
          return await response.json();
        } catch (error) {
          return null;
          console.error("Error checking Accessory Inventory");
        }
      }

      isBundledVariantInCart(cart, variantId) {
        return cart.items.some(item => item.variant_id == variantId && item.properties['_bundled-variant'])
      }
      isReformerInCart(cart) {
        return cart.items.some(item => item.properties['_bundle-product'])
      }


      async isValidPaymentPlan(paymentPlan, cart) {
        if (!paymentPlan) {
          return true;
        }
        const rfIDs = this.REFORMER_IDS

        const cartHasReformer = cart.items.some((p) => rfIDs.includes(p.product_id))
        const cartPaymentPlan = cart.attributes['_payment-plan'];
        if (cartPaymentPlan && cartHasReformer && cartPaymentPlan != paymentPlan) {
          return false;
        }
        return true;
      }

      async isValidLocation(selectedLocation, cart) {
        if (!cart) {
          return true;
        }

        const rfIDs = this.REFORMER_IDS

        const cartHasReformer = cart.items.some((p) => rfIDs.includes(p.product_id))
        const cartLocation = cart.attributes['_location'];
        if (cartLocation && cartHasReformer && cartLocation != selectedLocation) {
          return false;
        }
        return true;
      }

      async getAvailableQuantity(max, variantId, quantity) {
        if (!max) {
          // product is for preorder
          return quantity
        }
        const params = {
          type: 'GET',
          url: `${window.location.origin}/cart.json`,
        }
        const cart = await jQuery.ajax(params);

        const cartItem = cart.items.find((item) => `${item.variant_id}` === `${variantId}`)
        if (!!cartItem) {
          // this will return the available max quantity to add on the cart
          const available = parseInt(max) - cartItem.quantity;
          return available;
        }

        return max
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();
        const notif = document.querySelector('.reformer-add-error');
        const timestamp = Date.now();
        notif?.classList.add('d-none');
        const isReformer = this.REFORMER_IDS.includes(+this.productId);
        const varaintId = this.form.querySelector('[name=id]').value;
        const currentSubmitButton = this.querySelector(`[type="submit"][data-variant="${varaintId}"]`) || this.querySelector(`[type="submit"]`);

        if (currentSubmitButton.getAttribute('aria-disabled') === 'true') return;

        if (isReformer) {
          const paymentPlanInputValue = $('.payment-plan-variant-wrapper.active [id^="payment-plan"][checked="checked"]')?.val();
          if (!paymentPlanInputValue) {
            const productPaymentWrapper = document.querySelector('.product-payment');
            if (paymentPlanMessage) {
              productPaymentWrapper.classList.remove('d-none');
              paymentPlanMessage.classList.add('show');
            }
            return
          }
        }

        const quantityInput = this.form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
        const quantitySelect = document.querySelector('select[name="quantity"]')
        const mainProductVariantId = document.querySelector('product-info .buy-buttons-wrapper [name=id]')?.value;
        // const quantity = quantityInput?.value > quantitySelect?.value ? quantityInput?.value : quantitySelect?.value;
        const quantity = quantityInput?.value;
        const availableQuantity = await this.getAvailableQuantity(quantitySelect?.dataset.max || quantityInput?.getAttribute('max'), varaintId, quantity);
        if (parseInt(availableQuantity) < parseInt(quantity)) {
          return this.handleErrorMessage('Selected quantity unavailable.')
        }

        const propertiesValue = this.form.querySelector('input[name*="properties"]')?.value;
        let propertiesKey = this.form.querySelector('input[name*="properties"]')?.getAttribute('name').replace("properties[", "").replace("]", "")
        let freeProduct, includedProduct, selectedPlan, _location, bundledVariant, bundledProductVariant, inclusionItems = null;
        const productInfo = this.form.closest('product-info');
        const productPayment = document.querySelector('.payment-plan-body');
        const sectionId = this.dataset.sectionId;
        const inclusionsWrapper = document.querySelector('#product-inclusions');

        if (productPayment && sectionId != 'essentialsVariantCart' && sectionId != 'buy-it-with') {
          // freeProduct = productPayment.querySelector('#payment-plan[checked="checked"]')?.dataset.freeProduct;
          if (inclusionsWrapper) {
              bundledVariant = document.querySelector('#product-inclusions .inclusion-item-bundled-variant input[data-checked]')?.dataset.variant;
              bundledProductVariant = document.querySelector('#product-inclusions .inclusion-item-bundled-product input[data-checked]')?.dataset.variant;
              includedProduct = document.querySelector('#product-inclusions .inclusion-item-yr-app')?.dataset.variant;
              inclusionItems = inclusionsWrapper.querySelectorAll('.inclusion-item[data-add-to-cart="true"]');
            }
          selectedPlan = productPayment.querySelector('.payment-plan-variant-wrapper.active [id^="payment-plan"][checked="checked"]')?.value;
          // _location = document.querySelector('[name="_location"]:checked')?.value;
          const essentialsProduct = document.querySelector('.essentials.product');
          if (essentialsProduct && sectionId != 'essentialsVariant' && sectionId != 'essentialsVariantCart') {
            const message = essentialsProduct.querySelector('.essentials_col2-message');

            const radioInput = essentialsProduct.querySelector('.essentials_col2 input[type="radio"]:checked');
            if (radioInput) {
              bundledProductVariant = radioInput.dataset.variant;
            } else {
              const dropdown = essentialsProduct.querySelector('.color-dropdown:not(.variant-dropdown)');
              if (dropdown) {
                const selectedOption = dropdown.options[dropdown.selectedIndex];
                if (selectedOption && selectedOption.value && selectedOption.value !== "") {
                  bundledProductVariant = selectedOption.getAttribute('data-variant');
                }
              }
            }

            if (!bundledProductVariant) {
              message.style.display = "block"
              return;
            }
          }
        }
        this.handleErrorMessage();
        currentSubmitButton.setAttribute('aria-disabled', true);
        currentSubmitButton.classList.add('loading');
        currentSubmitButton.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';


        const ajaxParams = {
          type: 'GET',
          url: `${window.location.origin}/cart.json`,
        }

        const cart = await jQuery.ajax(ajaxParams);

        if (window.EducationCartRules?.isEnabled()) {
          const requiresShipping =
            this.submitButton?.getAttribute('data-requires-shipping') === 'true';
          const validation = EducationCartRules.validateAddToCart(cart, {
            productId: this.productId,
            variantId: varaintId,
            quantity: parseInt(quantity, 10) || 1,
            requiresShipping,
          });
          if (!validation.ok && validation.message) {
            this.handleErrorMessage(validation.message);
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            return;
          }
        }

        const isValidPlan = await this.isValidPaymentPlan(selectedPlan, cart);
        const isValidLocation = await this.isValidLocation(_location, cart);
        if (notif) {
          if (!isValidPlan && sectionId != 'buy-it-with' && sectionId != 'essentialsVariantCart') {
            notif.classList.remove('d-none');
            notif.innerHTML = 'Cannot add multiple payment options. Clear your cart before adding this payment type.';
            currentSubmitButton.classList.remove('loading');
            currentSubmitButton.removeAttribute('aria-disabled');
            currentSubmitButton.querySelector('.loading__spinner').classList.add('hidden')
            return
          }

          if (!isValidLocation && sectionId != 'buy-it-with' && sectionId != 'essentialsVariantCart') {
            notif.classList.remove('d-none');
            notif.innerHTML = 'Please clear your cart before adding a reformer from this location.';
            currentSubmitButton.classList.remove('loading');
            currentSubmitButton.removeAttribute('aria-disabled');
            currentSubmitButton.querySelector('.loading__spinner').classList.add('hidden')
            return
          }
        }


        // const isBundledProductAvailable = await this.checkBundledProductInventory(bundledProductVariant, _location);
        // if (isBundledProductAvailable == false) {
        //   const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
        //   const errorMessageWrapperSpan = errorMessageWrapper?.querySelector('span');
        //   const locationTitle = document.querySelector('[name="_location"]:checked')?.getAttribute('data-location');
        //   errorMessageWrapper.removeAttribute('hidden');
        //   errorMessageWrapperSpan.textContent = `It looks like the selected "Prop Starter Kit" variant isn’t available in ${locationTitle} right now. Please choose another color or select a different location to continue.`;
        //   this.submitButton.classList.remove('loading');
        //   this.submitButton.removeAttribute('aria-disabled');
        //   this.querySelector('.loading__spinner').classList.add('hidden');
        //   return;
        // }

        // if (isBundledProductAvailable == null) {
        //   bundledProductVariant = null;
        // }


        let formData = {
          'items': [
            { 'id': varaintId, 'quantity': quantity ?? 1 }
          ],
          'attributes': {}
        };
        if (propertiesValue && propertiesKey) {
          formData.items[0].properties = { [propertiesKey]: propertiesValue };
        }
        if (sectionId == "essentialsVariantCart") {
          formData.items[0].properties._essentials = "true";
        } else if (sectionId == 'essentialsVariant') {
          if (this.isBundledVariantInCart(cart, varaintId)) {
            notif.classList.remove('d-none');
            notif.innerHTML = 'This upsell is already in the cart.';
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden')
            return;
          }
          if (!this.isReformerInCart(cart)) {
            notif.classList.remove('d-none');
            notif.innerHTML = 'Please add the Reformer first.';
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden')
            return;
          }
          formData.items[0].properties = { '_bundled-variant': `${mainProductVariantId}`, '_essentials': 'true' };
        } else if (sectionId != 'buy-it-with') {
          if (!selectedPlan) {
            this.handleErrorMessage('An error occurred. Please reload the page and try again');
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
          // formData.attributes['_location'] = document.querySelector('input[name="_location"]:checked')?.value;
          formData.attributes['_payment-plan'] = document.querySelector('input[name="payment-plan"][checked="checked"]')?.value;
          formData.items[0].properties = { '_bundle-product': mainProductVariantId, '_timeStamp': timestamp, '_location': document.querySelector('[name="_location"]:checked')?.value };
          //Rental Essentials Pack
          if (bundledVariant && selectedPlan == 'BOND') {
            formData.items.push({
              'id': bundledVariant, 'quantity': 1, 'properties': {
                '_bundle-gift': `${varaintId}`,
                '_timeStamp': timestamp,
              }
            });
          }
          else if (bundledVariant) {
            formData.items.push({
              'id': bundledVariant, 'quantity': 1, 'properties': {
                '_bundled-variant': `${varaintId}`,
                '_timeStamp': timestamp,
              }
            });
          } 
          // UNCOMMENT AND ADD CONDITION != "YR_PAYMENT_PLAN IN THE ELSE IF ABOVE IF WE DECIDE TO CHARGE FOR JUMBOARD AND BOX FOR PAYMENT PLAN"
          // else {
          //   formData.items.push({
          //     'id': bundledVariant,
          //     'quantity': 1,
          //     'properties': {
          //       '_timeStamp': timestamp,
          //       '_bundled-variant': `${varaintId}`,
          //       '_essentials': 'true'
          //     }
          //   });
          // }
          if (bundledProductVariant) {
            formData.items.push({
              'id': bundledProductVariant, 'quantity': 1, 'properties': {
                '_bundled-product': `${varaintId}`,
                '_timeStamp': timestamp,
              }
            });
          }
          // if (freeProduct) {
          //   let freeProducts = freeProduct.split(',');
          //   freeProducts.forEach(freeproduct => {
          //     formData.items.push({
          //       'id': freeproduct, 'quantity': 1, 'properties': {
          //         '_bundle-gift': `${varaintId}`,
          //         '_timeStamp': timestamp,
          //       }
          //     });
          //   });
          // }
          if (inclusionItems) {
            inclusionItems.forEach(inclusion => {
              var variantId = '';
              if (inclusion.dataset.hasSwatches == "true") {
                variantId = inclusion.querySelector('input[data-checked]')?.dataset.variant;
              } else {
                variantId = inclusion.dataset.variant;
              }
              let asBundled = inclusion.dataset.asBundledProduct;
              if (variantId) {
                formData.items.push({
                  'id': variantId,
                  'quantity': 1,
                  'properties': {
                    '_timeStamp': timestamp,
                    ...(asBundled === 'true' && { '_bundle-gift': `${varaintId}` })
                  }
                });
              }
            });
          }
          if (includedProduct) {
            formData.items.push({
              'id': includedProduct, 'quantity': 1, 'properties': {
                '_bundle-included': `${varaintId}`,
                '_timeStamp': timestamp,
              }
            });
          }
        }
        // let attr = {
        //   "_fromB2B": null,
        // };
        // if (selectedPlan || _location) {
        //     if(_location && sectionId != 'buy-it-with' && sectionId != 'essentialsVariantCart' && sectionId != 'essentialsVariant') {
        //       attr["_location"]= _location
        //     }
        //     if(selectedPlan && sectionId != 'buy-it-with' && sectionId != 'essentialsVariantCart' && sectionId != 'essentialsVariant') {
        //       attr["_payment-plan"]= selectedPlan
        //     }
        //   }
        //  const attributesResponse =  await fetch('/cart/update.js', {
        //   method: "POST",
        //   headers: {
        //       'Content-Type': 'application/json;'
        //   },
        //   body: JSON.stringify({
        //     attributes: attr
        //   })
        // });
        // if (!attributesResponse.ok) {
        //   this.handleErrorMessage('An error occurred. Please reload the page and try again');
        //   throw new Error("Error");
        // }
        formData.items = formData.items.reverse();
        config.body = JSON.stringify(formData);

        await fetch(`${routes.cart_add_url}?sections=cart-drawer,cart-icon-bubble`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: varaintId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = currentSubmitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              currentSubmitButton.setAttribute('aria-disabled', true);
              currentSubmitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: varaintId,
                cartData: response,
              });

            const cartData = await jQuery.ajax(ajaxParams);
            if (sectionId != 'essentialsVariantCart' && sectionId != 'buy-it-with') {
              // const cartLocation = cartData.attributes['_location'];
              const cartPaymentPlan = cartData.attributes['_payment-plan'];
              if (cartPaymentPlan != selectedPlan) {
                const attributes = { "_payment-plan": selectedPlan, "_fromB2B": null };
                await fetch(window.Shopify.routes.root + "cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ updates: {}, attributes }),
                });
              }
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            currentSubmitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) currentSubmitButton.removeAttribute('aria-disabled');
            currentSubmitButton.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}